export default "__VITE_ASSET__Seo8heHP__"